import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class MeNavBar extends Component {
    render() {
        const { to, title, buttonTitle, hideButton } = this.props;

        return (
            <div className="form-header">
                <div className="row">
                    <div className="col close-page-btn">
                        <Link className="cross-hover" to={to}>
                            <img src="/resources/img/ic-x.png" alt="close button" />
                        </Link>
                    </div>
                    <div className="col-8">
                        <h3>{title}</h3>
                    </div>
                    <div className="col">
                        {hideButton ? null :
                            <button className="btn button green-btn" type="submit">{buttonTitle}</button>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default MeNavBar;



// WEBPACK FOOTER //
// ./src/components/MeNavBar.jsx